module.exports = __webpack_public_path__ + "static/1_SINGLE-ac442c9926d1f893603588e31f1e16dc.png";